// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friends-status-modal__mode{color:#4a5568;background:#e6ebf0;border:1px solid #cbd5e0;border-radius:5px;-webkit-transition:all .25s ease-out;transition:all .25s ease-out;padding:1rem;margin-bottom:1rem}.friends-status-modal__mode--host{color:#000;background:#ffd01c;border-color:#d69e2e}.friends-status-modal__mode--guest{color:#fff;background:#68d391;border-color:#38a169}.friends-status-modal #field-own-peer-id{text-align:center;font-family:monospace;letter-spacing:.25em}", ""]);
// Exports
module.exports = exports;
